export const AGENT_PATTERNS = {
	AUTOMATIC: "AUTOMATIC",
	STREAM_ALL_PARAGRAPHS_BY_DBPAGES: "STREAM_ALL_PARAGRAPHS_BY_DBPAGES",
};

export const EXECUTION_STATUS = {
	CREATED: "CREATED",
	STARTED: "STARTED",
	COMPLETED_SUCCESS: "COMPLETED_SUCCESS",
	COMPLETED_FAILURE: "COMPLETED_FAILURE",
};
